import { useNavigate } from "react-router-dom";
import allImgPaths from "../../assets";

const Home = () => {
  const navigate = useNavigate();
  return (
    <main>
      {/* Navbar */}
      <section
        style={{
          // backgroundImage: `url(${allImgPaths.hero})`,
          background: "white",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="min-h-screen"
      >
        <nav className="w-full bg-transparent flex justify-between items-center px-20 2xl:px-64 py-4">
          {/* <img alt="Nav Logo" src={allImgPaths.logoNavbar} className="" /> */}
          <h1 className="font-manrope font-bold text-xl">
            {/* Ganicus Vyapar Sangram */}
            Logo
          </h1>
          <div className="flex space-x-8 items-center">
            <button
              className="px-5 py-3 bg-[#FFAA15] text-white rounded-md hover:bg-[#f8c46a]"
              onClick={() => navigate("/login")}
            >
              Login
            </button>
          </div>
        </nav>
        {/* Banner */}
        <div className="flex items-center justify-center h-[80vh] max-w-[700px] lg:max-w-[1150px] mx-auto">
          <div className="text-black text-center">
            <h1 className="text-[26px] lg:text-4xl 2xl:text-5xl font-bold mb-4 lg:mb-8">
              Ganicus Vyapar Sangram
            </h1>
          </div>
        </div>
      </section>
      <footer className="mt-10 spbp:mt-12 text-white">
        <div
          className="grid grid-cols-12 items-center gap-8 px-20 2xl:px-64 py-8 spbp:py-16"
          style={{
            backgroundImage: `url(${allImgPaths.footer})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="col-span-12 lg:col-span-8">
            {/* <img src={allImgPaths.logoNavbar} className="mb-8" /> */}
            <h1 className="font-manrope font-bold text-xl mb-8 text-white">
              {/* Ganicus Vyapar Sangram */}
              Logo
            </h1>
            <p className=" font-normal text-base text-left">
              Ganicus Vyapar Sangram
            </p>
          </div>
          <div className="col-span-12 lg:col-span-4">
            <div className="flex gap-5 items-center mb-5">
              <img src={allImgPaths.callfooter} />
              <p>+91 99988877777</p>
            </div>
            <div className="flex gap-5 items-center mb-5">
              <img src={allImgPaths.messagefooter} />
              <p>jon@doe.com</p>
            </div>
            <div className="flex gap-5 items-center">
              <img src={allImgPaths.locationfooter} />
              <div>
                <p>Address</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </main>
  );
};

export default Home;
